import { BookOpen, Bug, CircleHelp, Info, Keyboard, Terminal } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DOCS_URL, ISSUE_URL } from "@/lib/buildInfo";
import { HowToStartDialog } from "./HowToStartDialog";
import { ShortcutsDialog } from "./ShortcutsDialog";

export function HelpMenu() {
  const [shortcuts, setShortcuts] = useState(false);
  const [howTo, setHowTo] = useState(false);
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" aria-label="Help">
            <CircleHelp aria-hidden />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={() => setShortcuts(true)}>
            <Keyboard aria-hidden /> Keyboard shortcuts
          </DropdownMenuItem>
          {DOCS_URL && (
            <DropdownMenuItem asChild>
              <a href={DOCS_URL} target="_blank" rel="noopener noreferrer">
                <BookOpen aria-hidden /> Documentation
              </a>
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onSelect={() => setHowTo(true)}>
            <Terminal aria-hidden /> How to start ATS
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <a href={ISSUE_URL} target="_blank" rel="noopener noreferrer">
              <Bug aria-hidden /> Report an issue
            </a>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <Link to="/help#about">
              <Info aria-hidden /> About
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ShortcutsDialog open={shortcuts} onOpenChange={setShortcuts} />
      <HowToStartDialog open={howTo} onOpenChange={setHowTo} />
    </>
  );
}
